import React, { useState } from "react";
import Layout from "../../components/layouts/layout"
import { graphql } from "gatsby"
import DownloadIcon from "../../images/DownloadIcon.jpg"
import YoastSEO from "../../template-parts/head/seo"
import Breadcrumbs from "../../template-parts/blocks/breadcrumbs"
import AdjacentLinks      from "../../template-parts/sidebar/adjacentlinks"
//import AdjacentCategoryLinks from "../../template-parts/PostsSidebar/AdjacentCategoryLinks.js"
var _ = require('lodash');

/**
 * Convert bytes to Size
 */
 const convertBytes = function(bytes) {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"]

  if (bytes == 0) {
    return "n/a"
  }

  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))

  if (i == 0) {
    return bytes + " " + sizes[i]
  }

  return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i]
}

export default function BlogPost({ data }) {
  const post                = data.publicationCover.nodes[0];
  const postsOrder          = data.orderedData.nodes[0].contentOrder.postsInCategory;
  const yoast               = data.publicationCover.nodes[0].seo
  const breadcrumbs         = data.publicationCover.nodes[0].seo.breadcrumbs
  const publicationChildren = _.orderBy(post.wpChildren.nodes, ['menuOrder'],['asc']);
  const publicationTypes    = post.ql_tax_publications.nodes;
  const filter = (arr, name, value) => arr.filter((obj) => (name in obj && obj[name] === value)).map((obj) => {
    const nObj = { ...obj };
    if (obj.content && Array.isArray(obj.content)) {
      nObj.content = filter(obj.content, name, value);
    }
    return nObj;
  });
  let adjacentLinks = '';
  if(post.categories.nodes[0]) {
    const currentCategoryID   = post.categories.nodes[0].databaseId;
    const postsInOrder  = filter(postsOrder, "category_id", currentCategoryID);
    //console.log(post.categories.nodes[0].posts.nodes);
    //console.log(postsInOrder);
    let merged = _.merge( _.keyBy(post.categories.nodes[0].posts.nodes, 'databaseId'),_.keyBy(postsInOrder, 'post_id'));
    merged =  Object.entries(_.orderBy(merged, ['id'],['asc']));
    
    //console.log(merged);
    adjacentLinks = {
      sidebarHeader: {
        sidebarTitle:post.categories.nodes[0].name,
        sidebarLink:post.categories.nodes[0].uri
      },

      sidebarLinks: merged,
    }
  }else {
    adjacentLinks = null
  }




  let publicationPublicationModificationDates = '';

  if(post.acf_PublicationsData.publicationDatepublished || post.acf_PublicationsData.publicationDatemodified) {
    publicationPublicationModificationDates = <div className="publication-updates mtop-20">
    <p>Published {post.acf_PublicationsData.publicationDatepublished} </p>
    <p>Modified {post.acf_PublicationsData.publicationDatemodified}</p>
  </div>
  }

  let publicationTypeData     = [];
  let publicationDetails      = [];
  let publicationChildrenData = [];
  let publicationTypeUi       = '';
  let publicationWcag         = '';
  let publicationUrl          = '';
  let publicationMetaData     = '';
  let publicationsUpdateDetailItems = [];
  let publicationsUpdates     = '';


  /**
   * Control to handle toggle - show/hide
   */
  const [isActive, setActive] = useState("false");
    const handleAllToggle = () => {
      setActive(!isActive);
  };
  /**
   * 
   * If there are updates:
   * - map each 1 to the array item with html of <li>
   * - update publicationsUpdates with the surrounding html for the "show all"
   * 
   * If null, then don't do anything.
   */
  if(post.acf_PublicationsData.updates !== null) {

    publicationsUpdateDetailItems = post.acf_PublicationsData.updates.map((update)=> {
      if(update.updateDate !== null) {
        return (
          <li>
            <time>{update.updateDate}</time>
            <p>{update.whatWasUpdated}</p>
          </li>
        )
      }
    })

   publicationsUpdates = 
  <div className="publication-update-details">
    {publicationPublicationModificationDates}
    <h3>Updates</h3>
    <button className="inline-link" onClick={handleAllToggle}>Show all updates</button>
    <ul class={isActive ? "hidden" : ""}>
      {publicationsUpdateDetailItems}
    </ul>
  </div>;
  }

  const publicationTypeUiWebPage = 
      <div className="publication-icon">
        <span className="publication-type-label">Webpage</span>
          <svg width="7em" height="8em" viewBox="0 0 16 16" className="bi bi-text-left " fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>
          </svg>
      </div>;
const publicationNotWcag =
<div>
<p class="small mbottom-0">This file may not be suitable for users of assistive technology.</p><div class="reveal-component small-text clearfix"><p>If you use assistive technology (such as a screen reader) and need a version of this document in a more accessible format, please email digital@southglos.gov.uk. Please tell us what format you need. It will help us if you say what assistive technology you use.</p></div>
</div>;
  const publicationTypeUiFile = 
  <div className="publication-icon">
    <span><img src={DownloadIcon} alt=""/></span>
  </div>;

 
  for(const publicationType of publicationTypes) {
    publicationTypeData.push(
     publicationType.name
    )
  }

  if(post.acf_PublicationsData.publicationDetails !== null) {
    publicationDetails.push(
      post.acf_PublicationsData.publicationDetails 
    )
  }

  for(const publication of publicationChildren) {
    /**
     * If it is html then it is a webpage and will be deemed accessible
     * If it is a file then it may not be accessible
     */
    

    if(publication.acf_PublicationsData.publicationsSetup === 'html') {

      publicationTypeUi   = publicationTypeUiWebPage;
      publicationUrl      = publication.uri;
      publicationMetaData = publication.acf_PublicationsData.publicationsSetup.toUpperCase()
      publicationWcag = '';
    } else {
      publicationTypeUi   = publicationTypeUiFile
      if(publication.acf_PublicationsData.publicationContent && _.isNil(publication.acf_PublicationsData.publicationContent.fileUpload)) {
        publicationUrl = '';
        publicationMetaData = '';
      }else {
        if(publication.acf_PublicationsData.publicationContent && !_.isNil(publication.acf_PublicationsData.publicationContent.fileUpload.localFile)) {
        publicationUrl      = publication.acf_PublicationsData.publicationContent.fileUpload.localFile.localURL;
        publicationMetaData = publication.acf_PublicationsData.publicationContent.fileUpload.localFile.extension.toUpperCase() +', '+ convertBytes(publication.acf_PublicationsData.publicationContent.fileUpload.localFile.size);
        } else {
          publicationUrl = ''
          publicationMetaData = '';
        }
      }
      
      if(publication.acf_PublicationsData.publicationContent && publication.acf_PublicationsData.publicationContent.wcagCheck === 'no') {
        
        publicationWcag = publicationNotWcag
      } else {
        
        publicationWcag = '';
      }
    }
    publicationChildrenData.push(
      <div className="publication row mtop-40 clearfix">
        <div className="publication-type publication-type__html col-md-3 col-sm-20 col-xs-4">
          {publicationTypeUi}
        </div> 
        <div className="col-md-9 col-sm-80 col-xs-8">
          <a href={publicationUrl} className="heading3 underline-link">{publication.title}</a>
          <p className="document-type small mbottom-0">{publicationMetaData}</p>
          {publicationWcag}
        </div>
      </div>
    )
    //console.log(publicationChildrenData)
  }
  return (
    <Layout>
      <YoastSEO seoData={yoast}  title={post.title} wpSiteID={post.databaseId} wpContentType="post"/>
      <div className="page-container container">
        <Breadcrumbs breadcrumbData={breadcrumbs} />
        <article className="clearfix">
            <header className="publications-page-header">
                <p className="heading3">{publicationTypeData}</p>
                <h1>{post.title}</h1>
                <div className="entry-content" dangerouslySetInnerHTML={{ __html: post.content }} />
            </header>
            <div className="page-content row">
              <div className="col-md-8 col-xs-12">
                  {publicationPublicationModificationDates}
                  <h2 className="mbottom-20 heading2">Documents</h2>
                  <div className="associated-publications">
                  {publicationChildrenData}
                  </div>
                {publicationDetails && 
                <>
                 <div className="publication-details" dangerouslySetInnerHTML={{ __html: '<h4 class="heading2">Details</h4>'+publicationDetails }}/>         
                 {publicationsUpdates}
                </>
                }
              </div>
              <aside className="sidebar col-md-4 col-xs-12" aria-label="Additional information">
                <AdjacentLinks data={adjacentLinks}/>
              </aside>
            </div>
        </article>
        </div>
      </Layout>
  )
}
export const query = graphql`
query($uri: String!) {
    publicationCover:  allWpQlPublication(filter: {uri: {eq: $uri}}sort: {order: ASC, fields: menuOrder}) {
      nodes {
        slug
        uri
        title
        databaseId
        content
        ql_tax_publications {
          nodes {
            slug
            name
          }
        }
        acf_PublicationsData {
          updates {
            updateDate
            whatWasUpdated
          }
          publicationDetails
          publicationContent {
            fieldGroupName
            wcagCheck
          }
          publicationDatepublished
          publicationDatemodified
        }
        wpChildren {
          nodes {
            ... on WpQl_publication {
              title
              uri
              acf_PublicationsData {
                publicationContent {
                  wcagCheck
                  fileUpload {
                    title
                    localFile {
                      localURL
                      extension
                      size
                    }
                  }
                }
                publicationDetails
                publicationsSetup
                publicationDatepublished
                publicationDatemodified
              }
              menuOrder
            }
            id
          }
        }
        seo {
          canonical
          title
          metaDesc
          focuskw
          metaRobotsNoindex
          metaRobotsNofollow
          breadcrumbs {
            url
            text
          }
        }
        categories {
          nodes {
            name
            uri
            databaseId
            posts {
              nodes {
                title
                uri
                databaseId
              }
            }
          }
        }
      }
    } 
    orderedData: allWp {
      nodes {
        contentOrder {
          postsInCategory {
            category_id
            incl
            id
            post_id
          }
        }
      }
    }
  }
`